export default __webpack_public_path__ + "static/media/190629_190332_P1000242.3ba78645.jpg";